import styled from 'styled-components';
import { hexToRgb } from 'ui/styled';
import { theme } from 'ui/theme-color';
import Wrapper from '../Wrapper';

export const FormalizaBancoWrapper = styled(Wrapper)`
  #modal-content {
    width: 70vw;
  }
`;

export const FormalizaInfosContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const FormalizaInfoItemContainer = styled.span`
  display: flex;
  justify-content: center;
  gap: 4px;
`;

export const FormalizaInfoTextContainer = styled.p`
  margin: 0;
  display: flex;
  gap: 4px;
`;

export const FormalizaInfoTextTitle = styled.p`
  font-weight: bold;
  color: ${theme.palette.blue.main};
  margin: 0;
`;

export const FormalizaWarningContainer = styled.div`
  background-color: rgba(${hexToRgb(theme.palette.warning.main)}, 0.3);
  padding: 1rem;
  border: 1px solid ${theme.palette.warning.main};
  border-radius: 8px;
  font-size: 14px;
`;

export const FormalizaWarningTitle = styled.p`
  font-weight: bold;
  // @see https://developer.mozilla.org/en-US/docs/Web/CSS/Reference/Values/color_value/color-mix
  color: color-mix(in srgb, ${theme.palette.warning.main} 40%, black);
  margin: 0;
  padding-left: 0.6rem;
`;

export const FormalizaStepContainer = styled.div`
  overflow: hidden;
  display: grid;
  grid-template-columns: 2fr 1fr;
  width: 100%;
  border: 1px solid ${theme.palette.info.main};
  border-radius: 16px;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const FormalizaStepMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 4rem;
  border-right: 1px solid ${theme.palette.info.main};
`;

export const FormalizaStepCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 1rem;
`;

export const CompanyButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  gap: 16px;
  border-top: 1px solid ${(props) => props.theme.palette.colors.border};
  padding-top: 24px;
`;

export const CloseContainer = styled.div.attrs({})`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

//estilo do texto do modal
export const FormText = styled.div.attrs({})`
  font-family: Kumbh Sans;
  font-size: 18px;
  font-weight: 400;
  line-height: 35px;
  text-align: left;
`;
